// Wraps any amazon.com URL with the configured affiliate tag.
// Set REACT_APP_AMAZON_AFFILIATE_TAG in /app/frontend/.env to enable.
const AMAZON_TAG = (process.env.REACT_APP_AMAZON_AFFILIATE_TAG || "").trim();

export const withAffiliate = (url) => {
  if (!url || !AMAZON_TAG) return url;
  try {
    const u = new URL(url);
    if (!/amazon\.[a-z.]+$/i.test(u.hostname)) return url;
    u.searchParams.set("tag", AMAZON_TAG);
    return u.toString();
  } catch {
    return url;
  }
};

export const hasAmazonTag = () => Boolean(AMAZON_TAG);
